import { useEffect, useState } from 'react';
import { loginNewWrapper, lx } from '@cap/rzmt-core';
import { UserInfo } from '@cap/account';
import { Dropdown } from '@ss/mtd-react3';

import './index.less';

export default function UserName() {
  const [userInfo, setUserInfo] = useState<UserInfo | null>();

  const getUserInfo = async () => {
    const user = await loginNewWrapper.getUserInfo();
    setUserInfo(user);
  };

  const handleGoLogin = () => {
    lx.moduleClick({
      bid: 'b_donation_gk9cc4ta_mc',
    });
    loginNewWrapper.goLogin();
  };

  const handleLogout = () => {
    lx.moduleClick({
      bid: 'b_donation_ihrnrfpi_mc',
    });
    loginNewWrapper.logout(window.location.href, true);
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const menu = (
    <div className="top-head-user-menu">
      <div className="user-menu-item" onClick={handleLogout}>
        退出登录
      </div>
    </div>
  );

  return (
    <div className="head-user-name">
      <img src="//img.meituan.net/mtdxweb/ece20f5690713992dc2f5c6acc58113b1636.png" alt="avatar" className="avatar" />
      {userInfo ? (
        <>
          <Dropdown content={menu}>
            <div className="user-name">{userInfo.userName}</div>
          </Dropdown>
          <img src="//img.meituan.net/mtdxweb/80f992fc7a74e416bbe7160bb2818728298.png" alt="arrow" className="arrow" />
        </>
      ) : (
        <div className="user-name" onClick={handleGoLogin}>
          立即登录
        </div>
      )}
    </div>
  );
}
